import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule, MatDialogModule, MatFormFieldModule, MatInputModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { FcSendEmailMessageDialogComponent } from './fc-send-email-message-dialog.component';

@NgModule({
  entryComponents: [
    FcSendEmailMessageDialogComponent
  ],
  declarations: [
    FcSendEmailMessageDialogComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    TranslateModule
  ],
  exports: [
    FcSendEmailMessageDialogComponent
  ]
})
export class FcSendEmailMessageDialogModule { }

